<template>
	<div class="allchain">
		<leftnav class="fl" mkcode=" L" :itemcode="yj_itemcode" v-title data-title="全国产业图谱"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab">
						<span class="title current">全国重点产业链</span>
						<span class="title" @click="freeRouter()">本市推荐产业链</span>
						<span class="title" @click="freeRouter()">关注的产业链</span>
						<a href="https://c.ocn.com.cn/special/industryAtlas/" target="_blank" class="dib ml-5 orgfont">产业招商图谱 编制服务></a>
						<div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>  
						<div class="opport-screen-list1">
							<dl class="opport-screen bdbe">
								<dt class="fl">大分类</dt>
								<dd class="fl">
									<span :class="searchtype == list.value?'a-screen current':'a-screen'"
										@click="searchtype = list.value;onClickBigClas(list)" :key="i"
										v-for="(list,i) in biglist">{{list.name == '信息技术' ?'数字经济':list.name}}({{ list.num }})
									</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">小分类</dt>
								<dd class="fl">
									<span :class="searchtype1 == 0?'a-screen current':'a-screen'"
										@click="searchtype1=0;getchainlist(0)">全部</span>
									<span :class="searchtype1 == list.value?'a-screen current':'a-screen'"
										@click="searchtype1=list.value;getchainlist(list.value)" :key="i"
										v-for="(list,i) in smalllist">{{list.name}}({{ list.num }})</span>
									<span class="dib py-1 ml-5 orgfont">260多条动态产业链图谱，覆盖所有重点产业。查看产业链方便，还能一键查看企业详情，特别方便！</span>

								</dd>

							</dl>

						</div>
					</div>
				<ul class="hotchain-list oh whitebox" style="padding: 30px 0;margin-top: 10px;">
					<li v-for="(list,index) in chainlist" :key="index" @click="chainrouter1(list.chainId)" class="fl">
						<div class="imgbox">
							<img :src="list.image" v-bind:alt="list.chainName">
						</div>
							<h5 class="title dib">{{list.chainName}}</h5> <span class="red-font dib" v-if="list.chainId == 44">(参考样板：可浏览完整内容)</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'allchain',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "全国图谱-更多产业图谱",
				curWebsite:this.$api.getWebsiteType(),
				userdata: {},
				searchtype: 0,
				searchtype1: 0,
				navtype: 0,
				searchtext: '',
				yj_itemcode:"",
				biglist: [{
						name: "数字经济",
						value: 10561, 
						itemcode:"L-SZJJ",
					},
					{
						name: "高端制造",
						value: 10562,
						itemcode:"L-GDZZ",
					},
					{
						name: "能源环保材料",
						value: 10563,
						itemcode:"L-NYHBCL",
					},
					{
						name: "大健康",
						value: 10560,
						itemcode:"L-DJK",
					},
					{
						name: "现代服务业",
						value: 10637,
						itemcode:"L-XDFWY",
					},
					{
						name: "大消费",
						value: 10644,
						itemcode:"L-DXF",
					},
					{
						name: "未来产业",
						value: 13450,
						itemcode:"L-DXF",
					},
				],
				smalllist: [],
				chainlist: [],
				isShowFreeUserTips:false,
			}
		},
		watch: {
				$route: function (newVal,oldVal) {  
						if(this.$route.query.bc){
							let quertyType=this.$route.query.bc;
							let quertyType1 = this.$route.query.sc;
							this.searchtype1 = quertyType1?quertyType1:'';
							this.searchtype=quertyType?quertyType:10561;
							console.log(this.searchtype,this.searchtype1);
							this.getparameterList(this.searchtype);
						} 
				}
		}, 
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			// this.userdata = this.getuseriformation();
				this.isshowWaterMark = true; 
			this.getparameterList(this.searchtype);
			

			// this.searchtype=this.biglist[0].value;
			let quertyType=this.$route.query.bc;
			let quertyType1 = this.$route.query.sc;
			this.searchtype1 = quertyType1?quertyType1:'';
			this.searchtype=quertyType?quertyType:10561;
			this.getchainlist();
			console.log(this.searchtype,this.searchtype1);
		},
		mounted() {},
		methods: {
			onClickBigClas(list){
				this.getparameterList(list.value);
				this.searchtype1=0;
				this.getchainlist(list.value);
			},
			freeRouter(){
				this.isShowFreeUserTips = true;
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			//搜索关键词
			searchkwfun() {
				this.isShowFreeUserTips = true;
				return;
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext == "") {
					this.$message({
						type: 'warning',
						message: "搜索信息不能为空"
					})
					return;
				}
				this.getchainlist('search'); 
			},
			chainrouter1(chainid) {
				let routeUrl = this.$router.resolve({
					path: '/chain',
					query: {
						id: chainid
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			getparameterList(value) {
				var _this = this;
				var ajaxurl = this.$api.free.parameter.chain() + '?parentValue=' + value;
				this.biglist.forEach(list=>{
					 if(list.value == value){
						this.yj_itemcode=list.itemcode;
						}
				});
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					if (res.data.success) {
						console.log('产业链参数',res)
						if (value != '') {
							_this.smalllist = res.data.list;
						} else {
							let temData = res.data.list;
							temData.forEach((list)=>{
								_this.biglist.forEach((item)=>{
									if(item.value == list.value){
										item.num = list.num;
									}
								})
							})
							// _this.biglist=res.data.list; //本地写死顺序
							// _this.searchtype = _this.biglist[0].value;
							_this.getparameterList(_this.searchtype);
						}
						// _this.getchainlist();
					} else {

					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			getchainlist(type) {
				var _this = this;
				this.bus.$emit('loading', true);
				if (type == "search") {
					var ajaxurl = this.$api.free.chain.list() + '?kw=' + _this.searchtext;
				} else {
					this.searchtext = "";
					var ajaxurl = this.$api.free.chain.list() + '?bigClass=' + _this.searchtype + '&smallClass=' + _this
						.searchtype1;
				}
				this.$axios.get(ajaxurl).then(function(res) {
					if (res.data.success) {
						console.log('产业链',res,ajaxurl);
						_this.chainlist = res.data.list;
						_this.bus.$emit('loading', false);
					} else {

					}
				}).catch(function(error) {
					_this.bus.$emit('loading', false);
					// 请求失败处理 console.log(error);
				});
			}

		},
	}
</script>

<style>

</style>